module.exports = __webpack_public_path__ + "static/media/artwok-redeem.306a65ec.png";